import React from 'react'
import moment from 'moment'
import HtmlToReact from 'html-to-react'
var HtmlToReactParser = HtmlToReact.Parser;
var htmlToReactParser = new HtmlToReactParser();


class PrintExam extends React.Component {

  constructor(props){
    super(props)
  }
  
 

render(props) {
    const record= this.props.record
    const classes = this.props.classes
    var questions = [];
    var answers=[];

    if(record && record.questions){
        try{
          questions =JSON.parse(record.questions) 
        } catch(e) {
          questions = record.questions;
        };
    }

    if(record && record.answers){
        try{
            answers =JSON.parse(record.answers) 
        } catch(e) {
        answers = record.answers;
        };
       /* try{
            answers =record.answers.split(',')
        } catch(e) {
        };*/
    }

    return(
  
        <div className={classes.root}>
        <div className={classes.title}>
            <h2>{(record.training_name)?((record.training_name)?record.training_name:''):''}</h2>
            <h3>{(record.exam_name)?((record.exam_name)?record.exam_name:''):''}</h3>
            <p className={classes.p}>
                <b>Candidate:&nbsp;</b>{record.full_name?record.full_name:''}&nbsp;&nbsp;&nbsp;&nbsp;
                <b>Exam Result:&nbsp;</b>{record.ispass===1? 'PASS' : 'FAIL'}&nbsp;({record.marks_per}%)&nbsp;&nbsp;&nbsp;&nbsp;
                <b>Exam Date:&nbsp;</b>{moment(Date()).format('MM/DD/yyyy')}</p>
        </div>
        {questions && questions.map((item, index) =>(
            <p key={index}><font color="navy" size="2">
            <span>{htmlToReactParser.parse(item['passage'])}</span>
            {index + 1}) {item['quest']}<br/></font>
            {item['Choices'] && item['Choices'].map((ans, i)=>
                <span  key={i+500}><font color={"grey"} size="2" >&nbsp;&nbsp;&nbsp;{i + 1}.</font>
                    <input type="radio" value={ans['answer']} name={index} checked={ans['answer'] === answers[index]? true: false} disabled/>
                    <font color={"grey"} size="2">{ans['answer']}
                    {(ans['answer'] === answers[index])&& ans['isAnswere']?  <span><font color='green'>&nbsp;&#10004;</font></span>: ''}
                    {(ans['answer'] === answers[index])&& !ans['isAnswere']? <span><font color='red'>&nbsp;&#10060;</font></span>: ''}</font><br/>
                </span>
                )
            }
            </p>
        ))
        }
        <hr/>
        <p className={classes.p2}><span>** Passing Socre:&nbsp;{record.passing_per}%</span></p>
        </div>
    )
    }
}

export default PrintExam